import React, { useState } from "react";
import "../../page_content.css";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";

const MOU = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <h1 className="title">MOU</h1>
      <hr />
      <div className="page-content-container">
        <p>
          MANET Training and Placement (T and P) department works on two
          segments of training: Technical and Non-technical
        </p>

        {/* accordion */}
        <Accordion
          title="1. MoU signed between MANET, MIT ADT University, Pune and The Naval Connection (TNC) "
          isActive={activeIndex === 0}
          onClick={() => handleToggle(0)}
        />
        {activeIndex === 0 && (
          <div className="accordion-content">
            <p>
              MANET happy to share that the MoU has been signed between
              Maharashtra Academy of Naval Education and Training (MANET), MIT
              ADT University Pune and Ocean Sparkle Limited (OSL), Hyderabad,
              Telangana on 21st February 2024.
            </p><p>Adani Ports and Special Economic
              Zone Ltd (“APSEZ”) through its subsidiary. The Adani Harbour
              Services Ltd (“TAHSL”), has entered into a definitive agreement
              for acquisition of 100% stake in Ocean Sparkle Ltd (‘OSL’), which
              is India’s leading marine services provider.
            </p>
            <div id="page-links">
              <p>For MOU Copy :</p>
              <a
                href="https://drive.google.com/file/d/1bgKjcZexCB4e7DtWWz6TrYSo7XVXEwaU/view?usp=drive_link"
                download
              >
                <button>Download PDF</button>
              </a>
            </div>
          </div>
        )}

        <Accordion
          title="2. MoU signed between MANET, MIT ADT University, Pune and Training Ship Rahaman (TS Rahaman)"
          isActive={activeIndex === 1}
          onClick={() => handleToggle(1)}
        />
        {activeIndex === 1 && (
          <div className="accordion-content">
            <div className="accordion-content">
              <p>
                MANET happy to share that the MoU has been signed between
                Maharashtra Academy of Naval Education and Training (MANET), MIT
                ADT University Pune and Cordelia Marine Services LLC, RAK, Dubai
                on 2 nd February 2024.</p><p>Cordelia stands for Solutions simplified
                  on various and most aspects of Shipping and Maritime transport.
                  Cordelia Marine Services is prominent Ship Management, Project
                  Management Company which also has expertise in Ship surveys,
                  inspections and Audits. Cordelia Marine Services deal with Ship
                  Owners, managers, agents and shipping service providers.
              </p>

              <img src="/assets/images/Placement/MoU2.webp"
                alt="MoU"
                style={{
                  width: "100%",
                  maxWidth: "clamp( 200px, 50vw, 500px)",
                  height: "auto",
                  display: "block",
                  margin: "20px auto",

                }}></img>
              <div id="page-links">
                <p>For MOU Copy :</p>
                <a
                  href="https://drive.google.com/file/d/1EBdBw5l7v_qF3i2Zz2WtxL-t6h8QPgZm/view?usp=drive_link"
                  download
                >
                  <button>Download PDF</button>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MOU;
